import { createReducer, Action, on } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';

const reducer = createReducer(
  initialState,
  on(actions.load, (state => {
    return {
      ...state,
      loading: true
    };
  })),
  on(actions.loadSuccess, ((state, { trades })  => {
    return {
      ...state,
      loading: false,
      data: trades
    };
  })),
  on(actions.loadFail, ((state, { error })  => {
    return {
      ...state,
      loading: false,
      error
    };
  })),
  on(actions.add, ((state, { trade })  => {
    return {
      ...state,
      loading: false,
      data: [
        ...state.data,
        trade
      ]
    };
  }))
);

export function tradesReducer(state: State, action: Action) {
  return reducer(state, action);
}
